export default __webpack_public_path__ + "static/media/padlock_blue_16px.a1b81023.png";